export const LOAD = 'ethstats/nodesList/LOAD';
export const LOAD_NODES_SUCCESS = 'ethstats/nodesList/LOAD_NODES_SUCCESS';
export const LOAD_NODES_FAIL = 'ethstats/nodesList/LOAD_NODES_FAIL';
export const INCREMENT = 'ethstats/nodesList/INCREMENT';
